import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no entity open
export const Route = createFileRoute('/_authenticated/geneea-entities/')({});
